import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { SERVICE_STATUS, BAG_STATUS, getPaxsTotalBags } from '@bagonboard/wiseman';

import placeholder from '../../../../../assets/img/placeholder.jpg';
import getBagDetails from '../../../../../modules/getBagStatusDetails';
import * as actions from '../../../../../reducers/Service/actions';
import { EditInput } from '../PickupDelivery/components';
import { Bag } from './components';
import {
  AddBagButton,
  AddBagContainer,
  AddBagIcon,
  BagsContainer,
  Container,
  DataContainer,
  Error,
  IdImage,
  PassengerContainer,
  Row,
  Span,
  SpanTitle,
  Text,
  Title,
  Warning,
} from './style';

const { TO_PICKUP } = BAG_STATUS;
const {
  CANCELLED,
  COMPLETED,
  DECLINED,
} = SERVICE_STATUS;

class PassengerBags extends Component {
  onAddBagClick = () => {
    const {
      id, pax, paxs, updateService,
    } = this.props;
    const newPaxs = paxs.map(item => ({
      ...item,
      _id    : undefined,
      bags   : item._id === pax._id ? [...item.bags, { status: TO_PICKUP }] : item.bags,
      numBags: item._id === pax._id ? item.numBags + 1 : item.numBags,
    }));

    const totalBags = getPaxsTotalBags(paxs);
    updateService({ bags: totalBags + 1, paxs: newPaxs, serviceId: id });
  };

  onEticketChange = (value) => {
    const {
      id, pax, paxs, updateService,
    } = this.props;
    const newPaxs = paxs.map(item => ({
      ...item,
      _id         : undefined,
      ticketNumber: item._id === pax._id ? value : item.ticketNumber,
    }));

    updateService({ paxs: newPaxs, serviceId: id });
  };

  onFrequentClientChange = (value) => {
    const {
      id, pax, paxs, updateService,
    } = this.props;
    const newPaxs = paxs.map(item => ({
      ...item,
      _id           : undefined,
      frequentClient: item._id === pax._id ? value : item.frequentClient,
    }));

    updateService({ paxs: newPaxs, serviceId: id });
  };

  onNameChange = (newName) => {
    const {
      id, pax, paxs, updateService,
    } = this.props;

    const newPaxs = paxs.map(({ name, ...rest }) => ({
      ...rest,
      _id: undefined,
      ...((rest._id !== pax._id)
        ? { name } // old value if this is not the passenger we are changing
        : (newName && { name: newName })), // newValue or null field if it is empty
    }));

    updateService({ paxs: newPaxs, serviceId: id });
  };

  onSurnameChange = (newSurname) => {
    const {
      id, pax, paxs, updateService,
    } = this.props;

    const newPaxs = paxs.map(({ surname, ...rest }) => ({
      ...rest,
      _id: undefined,
      ...((rest._id !== pax._id)
        ? { surname }
        : (newSurname && { surname: newSurname })),
    }));

    updateService({ paxs: newPaxs, serviceId: id });
  };

  onSeatNumberChange = (value) => {
    const {
      id, pax, paxs, updateService,
    } = this.props;
    const newPaxs = paxs.map(item => ({
      ...item,
      _id       : undefined,
      seatNumber: item._id === pax._id ? value : item.seatNumber,
    }));

    updateService({ paxs: newPaxs, serviceId: id });
  };

  render() {
    const {
      id,
      isCheckin,
      customer,
      pax,
      paxs,
      status,
      updateService,
    } = this.props;
    const {
      bags = [],
      frequentClient,
      name,
      numBags,
      photos = {},
      seatNumber,
      surname,
      ticketNumber,
    } = pax;
    const paxName = isCheckin ? name : customer.name;
    const paxSurname = isCheckin ? surname : customer.surname;
    const showAddBag = ![COMPLETED, CANCELLED, DECLINED].includes(status);

    return (
      <Container>
        <Row>
          <SpanTitle>Name</SpanTitle>
          {isCheckin ? (
            <EditInput onChange={this.onNameChange} value={paxName}>
              {paxName ? <Title>{paxName}</Title> : <Warning>Not found</Warning>}
            </EditInput>
          ) : (
            <Title>{paxName}</Title>
          )}
        </Row>
        <Row>
          <SpanTitle>Surname</SpanTitle>
          {isCheckin ? (
            <EditInput onChange={this.onSurnameChange} value={paxSurname}>
              {paxSurname ? <Title>{paxSurname}</Title> : <Warning>Not found</Warning>}
            </EditInput>
          ) : (
            <Title>{paxSurname}</Title>
          )}
        </Row>
        <PassengerContainer>
          <IdImage src={photos.idDocument || placeholder} alt="User Id" />
          <DataContainer>
            {isCheckin && (
              <Text>
                <Span>E-Ticket</Span>
                <EditInput onChange={this.onEticketChange} value={ticketNumber}>
                  {ticketNumber || <Error>Not found</Error>}
                </EditInput>
              </Text>
            )}
            {isCheckin && (
              <Text>
                <Span>Seat</Span>
                <EditInput onChange={this.onSeatNumberChange} value={seatNumber}>
                  {seatNumber || <Warning>Not found</Warning>}
                </EditInput>
              </Text>
            )}
            <Text>
              <Span>Bags</Span>
              {numBags || 0}
            </Text>
            {isCheckin && (
              <Text>
                <Span>Frequent Client</Span>
                <EditInput onChange={this.onFrequentClientChange} value={frequentClient}>
                  {frequentClient || <Warning>Not found</Warning>}
                </EditInput>
              </Text>
            )}
          </DataContainer>
          {showAddBag && (
            <AddBagContainer>
              <AddBagButton onClick={this.onAddBagClick}>
                <AddBagIcon />
                Add bag
              </AddBagButton>
            </AddBagContainer>
          )}
        </PassengerContainer>
        <BagsContainer>
          {bags.map((bag) => {
            const details = getBagDetails(bag.status);
            const bagPhotos = bag.photos || {};

            return (
              <Bag
                key={bag._id}
                bag={bag}
                bagPhotos={bagPhotos}
                details={details}
                id={id}
                pax={pax}
                paxs={paxs}
                updateService={updateService}
              />
            );
          })}
        </BagsContainer>
      </Container>
    );
  }
}

PassengerBags.propTypes = {
  id       : PropTypes.string,
  isCheckin: PropTypes.bool,
  customer : PropTypes.shape({
    name   : PropTypes.string,
    surname: PropTypes.string,
  }),
  pax: PropTypes.shape({
    _id           : PropTypes.string,
    bags          : PropTypes.arrayOf(PropTypes.shape({})),
    frequentClient: PropTypes.string,
    name          : PropTypes.string,
    numBags       : PropTypes.number,
    photos        : PropTypes.shape({}),
    seatNumber    : PropTypes.string,
    surname       : PropTypes.string,
    ticketNumber  : PropTypes.string,
  }),
  paxs         : PropTypes.arrayOf(PropTypes.shape({})),
  status       : PropTypes.string,
  updateService: PropTypes.func,
};

PassengerBags.defaultProps = {
  id       : '',
  isCheckin: false,
  customer : {
    name   : '',
    surname: '',
  },
  pax: {
    _id         : '',
    bags        : [],
    name        : '',
    numBags     : 0,
    photos      : {},
    seatNumber  : '',
    surname     : '',
    ticketNumber: '',
  },
  paxs  : [],
  status: undefined,
  updateService() {},
};

const mapDispatchToProps = dispatch => ({
  updateService: data => dispatch(actions.updateService(data)),
});

export default compose(
  connect(
    undefined,
    mapDispatchToProps,
  ),
)(PassengerBags);
